// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".taskCard.selected[data-v-68e87de1]{border-color:#000!important}", ""]);
// Exports
module.exports = exports;
